import CloseIcon from '@assets/images/common/icon/close.svg';
import { SupportServiceCategory } from '@src/api/types/supportServiceCategory';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import Input from '@src/ui/elements/form/Input';
import Select from '@src/ui/elements/form/Select';
import { firstError } from '@src/utils/errorMessageUtils';

export interface CategoryFields {
  name?: string;
  viewable?: number;
}

interface EditCategoryModalProps {
  isOpen: boolean;
  category: Partial<SupportServiceCategory> | null;
  onCategoryChange: (updatedCategory: Partial<SupportServiceCategory>) => void;
  errors?: {
    name?: string[];
    viewable?: string[];
  };
  onSave: () => void;
  onCancel: () => void;
}

const EditCategoryModal: React.FC<EditCategoryModalProps> = ({
  isOpen,
  category,
  onCategoryChange,
  errors,
  onSave,
  onCancel,
}) => {
  if (!isOpen) {
    return null;
  }

  const ViewableOptions = [
    { id: '1', name: 'あり' },
    { id: '0', name: 'なし' },
  ];

  const handleNameChange = (newName: string) => {
    onCategoryChange({
      ...category,
      name: newName,
    });
  };

  const handleViewableChange = (newViewable: string) => {
    onCategoryChange({
      ...category,
      viewable: newViewable !== undefined ? parseInt(newViewable) : undefined,
    });
  };
  return (
    <Modal width='500px'>
      <div className='flex grow flex-col gap-8 px-8 py-10'>
        <div className='border-b border-b-gray-350 pb-4'>
          <h2 className='text-lg font-semibold'>カテゴリを編集</h2>
        </div>
        <div className='flex flex-col gap-8'>
          <div className='flex flex-col gap-1'>
            <p>カテゴリ名</p>
            <Input
              value={category?.name ?? ''}
              onChange={(e) => handleNameChange(e.target.value)}
            />
            {errors?.name && <ErrorMessage>{firstError(errors.name)}</ErrorMessage>}
          </div>
          <div className='flex flex-col gap-1'>
            <p>メニュー表示</p>
            <Select
              items={ViewableOptions}
              initialValue={category?.viewable !== undefined ? category?.viewable?.toString() : ''}
              onSelect={handleViewableChange}
            />
            {errors?.viewable && <ErrorMessage>{firstError(errors.viewable)}</ErrorMessage>}
          </div>
        </div>
        <div className='mt-auto flex justify-center gap-5'>
          <div className='w-[172px]'>
            <Button
              variant='secondary'
              fullRounded
              fullWidth
              outline
              onClick={onCancel}
            >
              キャンセル
            </Button>
          </div>
          <div className='w-[172px]'>
            <Button
              fullRounded
              fullWidth
              outline
              onClick={onSave}
            >
              保存する
            </Button>
          </div>
        </div>
        <button
          className='absolute right-[8px] top-[8px] grid size-5 place-items-center rounded-full bg-gray-50'
          onClick={onCancel}
        >
          <img
            src={CloseIcon}
            alt=''
            width={16}
            height={16}
          />
        </button>
      </div>
    </Modal>
  );
};

export default EditCategoryModal;
